import { Injectable, signal } from '@angular/core';

import { AuthDetails } from '../models/models';

@Injectable({
    providedIn: 'root',
})
export class AuthDetailsStore {
    private _authDetails = signal<AuthDetails>({ authCode: '', authFlag: false });
    initialize() {
        this.updateAuthDetails({ authCode: '', authFlag: false });
    }
    getAuthDetails() {
        return this._authDetails();
    }

    updateAuthDetails(value: AuthDetails) {
        this._authDetails.set(value);
    }
}
